import { Box, Button, Typography } from "@mui/material";

import useAppTranslations from "../hooks/useAppTranslations";
import LandingWithoutForm from "../components/LandingWithoutForm";

import Translate from "../components/Translate";

export default function ThanksPage() {
  const { t } = useAppTranslations();

  return (
    <LandingWithoutForm
      headerTitle={t("thanks:title")}
      CardBodyContent={
        <Box
          className="rounded-2xl flex flex-col"
          sx={theme => ({
            py: 4,
            px: 4,
            background: theme.palette.background.default,
            border: `solid 1px ${theme.palette.grey[300]}`,

            [theme.breakpoints.down("sm")]: {
              border: "none",
              py: 1.5,
              px: 2
            }
          })}
        >
          <Box className="grow">
            <Typography variant="h2" fontSize={28} className="pb-8">
              <Translate src="thanks:subtitle" /> 🎉
            </Typography>
            <Typography variant="body2" className="pb-8">
              <Translate src="thanks:desc" />
            </Typography>
            <Button
              type="button"
              sx={{ marginTop: 4, py: 1.5 }}
              variant="contained"
              color="primary"
              fullWidth
              onClick={() =>
                window.location.replace(process.env.REACT_APP_BIZPIK_FRONT_URL as string)
              }
            >
              <Typography variant="button">{t("thanks:button_title")}</Typography>
            </Button>
          </Box>
        </Box>
      }
    />
  );
}
